import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container, Paper, Typography, TextField,
  Button, Box, Alert, Link, Grid,
  Grid2
} from '@mui/material';
import instance from '../utils/axiosConfig';
import { auth } from '../utils/auth';
import WelcomeLogin from '../assets/WelcomeLogin2.jpg';
import GradientBackground from '../components/GradientBackground';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import DarkBackground from '../components/DarkBackground';

const Login = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await instance.post('/api/auth/login', formData);
      
      if (!data.token) {
        throw new Error('No token received');
      }
      
      auth.setCredentials(
        data.token, 
        data.role,
        data.user.name,
        data.user
      );

      navigate('/');
    } catch (error) {
      console.error('Login error details:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status
      });
      setError(
        error.response?.data?.message || 
        error.message || 
        'Error al iniciar sesión'
      );
    }
  };

  return (
    <>
    {/* Show gradient background only on md breakpoint and up */}
    {!isMobile ? (
      <GradientBackground>
        <Container sx={{padding:{xs:'5% 0 0 0', md:'0px !important'}}} component="main" maxWidth="100vw">
         
          <Box  elevation={3} sx={{
            backgroundColor: "#FFFFFF",
             px: {xs:'5%', md:'3%'},
             py:{sm:'5%', md:'1%', lg:'2%'}, 
             mt: {sm:2, md:4, lg:8}, 
             mx: {lg:'35%'},
             borderRadius: 1,
             boxShadow: '0px 0px 10px 2px rgba(0, 0, 0, 0.1)',
          transition: 'all 0.3s ease-in-out'}}>
            <Typography component="h1" variant="h5" align="center" gutterBottom>
              Iniciar sesión con email
            </Typography>

            <Box component="form" onSubmit={handleSubmit} sx={{ mt: { md:1, lg:3} }}>
              <TextField
                required
                fullWidth
                label="Email"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                margin="normal"
              />
              
              <TextField
                required
                fullWidth
                label="Contraseña"
                name="password"
                type="password"
                value={formData.password}
                onChange={handleChange}
                margin="normal"
              />

              {error && (
                <Alert severity="error" sx={{ mt: 2 }}>
                  {error}
                </Alert>
              )}

              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
              >
                Iniciar sesión	
              </Button>

              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Link
                    component="span"
                    variant="body2"
                    onClick={() => navigate('/forgot-password')}
                    sx={{ cursor: 'pointer' }}
                  >
                    ¿Olvidaste tu contraseña?
                  </Link>
                </Grid>
                <Grid item xs={12}>
                  <Link
                    component="span"
                    variant="body2"
                    onClick={() => navigate('/signup-business')}
                    sx={{ cursor: 'pointer' }}
                  >
                    ¿Querés comprar? Regístrate aquí
                  </Link>
                </Grid>
                <Grid item xs={12}>
                  <Link
                    component="span"
                    variant="body2"
                    onClick={() => navigate('/signup-distributor')}
                    sx={{ cursor: 'pointer' }}
                  >
                    ¿Querés vender? Regístrate aquí
                  </Link>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Container>
      </GradientBackground>
    ) : (
      <Container sx={{backgroundColor: "#F4F4F4",height:'100vh',padding:{xs:'0 0 0 0',md:'0px !important'}}} component="main" maxWidth="100vw">
       
        <Box sx={{
          backgroundColor: "#F4F4F4",
           pt:4,
           width:'100%',
           px:3,
           py:4,
           mt: {sm:2, md:4, lg:8}, 
           borderRadius: '0',
        transition: 'all 0.3s ease-in-out'}}>
          <Typography component="h1" variant="h5" align="center" gutterBottom>
            Iniciar sesión con email
          </Typography>

          <Box component="form" onSubmit={handleSubmit} sx={{ mt: { md:1, lg:3} }}>
            <TextField
              required
              fullWidth
              label="Email"
              name="email"
              type="email"
              value={formData.email}
              onChange={handleChange}
              margin="normal"
            />
            
            <TextField
              required
              fullWidth
              label="Contraseña"
              name="password"
              type="password"
              value={formData.password}
              onChange={handleChange}
              margin="normal"
            />

            {error && (
              <Alert severity="error" sx={{ mt: 2 }}>
                {error}
              </Alert>
            )}

            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Iniciar sesión	
            </Button>

            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Link
                  component="span"
                  variant="body2"
                  onClick={() => navigate('/forgot-password')}
                  sx={{ cursor: 'pointer' }}
                >
                  ¿Olvidaste tu contraseña?
                </Link>
              </Grid>
              <Grid item xs={12}>
                <Link
                  component="span"
                  variant="body2"
                  onClick={() => navigate('/signup-business')}
                  sx={{ cursor: 'pointer' }}
                >
                  ¿Querés comprar? Regístrate aquí
                </Link>
              </Grid>
              <Grid item xs={12}>
                <Link
                  component="span"
                  variant="body2"
                  onClick={() => navigate('/signup-distributor')}
                  sx={{ cursor: 'pointer' }}
                >
                  ¿Querés vender? Regístrate aquí
                </Link>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Container>
    )}
    </>
  );
};

export default Login; 